import type { DataResponse } from '../types.tsx';
import { boardEtagCache } from './cache.tsx';

const BoardCache = {
	cache: {
		isBoardRoute: false,
		board: null,
	},
	initBoard(id: string | null, isBoardRoute: boolean) {
		const { cache } = this;
		// @ts-expect-error - TS2339 - Property 'id' does not exist on type 'never'.
		if (typeof id === 'string' && cache.board?.id !== id) {
			// @ts-expect-error - TS2540 - Cannot assign to 'board' because it is a read-only property.
			cache.board = {
				id,
				etag: '',
			};
		}
		// @ts-expect-error - TS2540 - Cannot assign to 'isBoardRoute' because it is a read-only property.
		cache.isBoardRoute = isBoardRoute;
	},
	async getETag() {
		const { isBoardRoute, board } = this.cache;
		let etag;
		if (isBoardRoute && board) {
			// @ts-expect-error - TS2339 - Property 'etag' does not exist on type 'never'. | TS2339 - Property 'etag' does not exist on type 'never'. | TS2339 - Property 'id' does not exist on type 'never'.
			etag = board.etag ? board.etag : await this.loadEtagFromStorage(board.id);
		}
		return etag || '';
	},
	async setETag(data: DataResponse) {
		const { isBoardRoute, board } = this.cache;
		if (isBoardRoute && board && typeof data?.etagData?.etag === 'string') {
			// @ts-expect-error - TS2339 - Property 'etag' does not exist on type 'never'.
			board.etag = data.etagData.etag;
			// @ts-expect-error - TS2339 - Property 'etag' does not exist on type 'never'. | TS2339 - Property 'id' does not exist on type 'never'.
			await this.persistEtag(board.etag, board.id);
		}
	},
	async persistEtag(etag: string | null, boardId: string | null) {
		if (etag != null && etag !== '' && boardId != null && boardId !== '') {
			await boardEtagCache.set(`${boardId}`, etag);
		}
	},
	async loadEtagFromStorage(boardId: string | null) {
		return boardId != null && boardId !== '' ? boardEtagCache.get(`${boardId}`) : '';
	},
} as const;

export default BoardCache;
